import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { getEntityImage } from '../../utils/assetUtils.js';

/**
 * A compact pinned bar showing the current product context at the top of the chat.
 * Displays when the chat is scoped to a specific product (on PDP page).
 */
const PinnedProductContext = ({ pageContext, product, isLoading = false, }) => {
    var _a;
    // Only show on PDP pages with a stacklineSku
    if ((pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType) !== 'pdp' || !(pageContext === null || pageContext === void 0 ? void 0 : pageContext.stacklineSku)) {
        return null;
    }
    const stacklineSku = pageContext.stacklineSku;
    // Get product image - from product metadata or construct from SKU
    const imageUrl = ((_a = product === null || product === void 0 ? void 0 : product.imageUrls) === null || _a === void 0 ? void 0 : _a[0]) || getEntityImage(stacklineSku, 'product');
    // Get product title and brand from metadata
    const productTitle = product === null || product === void 0 ? void 0 : product.title;
    const brandName = product === null || product === void 0 ? void 0 : product.brandName;
    // Loading skeleton
    if (isLoading) {
        return (jsxs("div", Object.assign({ style: {
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '10px 16px',
                backgroundColor: '#f8fafc',
                borderBottom: '1px solid #e2e8f0',
            } }, { children: [jsx("div", { style: {
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px',
                        backgroundColor: '#e2e8f0',
                        flexShrink: 0,
                    } }), jsxs("div", Object.assign({ style: {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                    } }, { children: [jsx("div", { style: {
                                height: '10px',
                                width: '80px',
                                borderRadius: '4px',
                                backgroundColor: '#e2e8f0',
                            } }), jsx("div", { style: {
                                height: '14px',
                                width: '150px',
                                borderRadius: '4px',
                                backgroundColor: '#e2e8f0',
                            } })] }))] })));
    }
    return (jsxs("div", Object.assign({ style: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '10px 16px',
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
        } }, { children: [jsx("div", Object.assign({ style: {
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e2e8f0',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }, { children: jsx("img", { src: imageUrl, alt: productTitle || 'Product', style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }, onError: (e) => {
                        // Hide image on error
                        e.target.style.display = 'none';
                    } }) })), jsxs("div", Object.assign({ style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1px',
                } }, { children: [jsx("span", Object.assign({ style: {
                            fontSize: '11px',
                            fontWeight: 500,
                            color: '#3b82f6',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                        } }, { children: "Chatting about" })), productTitle ? (jsxs(Fragment, { children: [jsx("span", Object.assign({ style: {
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#1e293b',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    lineHeight: '1.3',
                                }, title: productTitle }, { children: productTitle })), brandName && (jsx("span", Object.assign({ style: {
                                    fontSize: '11px',
                                    fontWeight: 400,
                                    color: '#64748b',
                                    lineHeight: '1.2',
                                } }, { children: brandName })))] })) : (jsx("span", Object.assign({ style: {
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#1e293b',
                            lineHeight: '1.3',
                        } }, { children: "This product" })))] }))] })));
};

export { PinnedProductContext };
//# sourceMappingURL=PinnedProductContext.js.map
